import type {
	FilterDataProperty as CoinListTableProperties,
	sortDirectionType,
} from 'components/CoinListTable/types';
import type { FilterDataProperty as ExchangesTableProperties } from 'components/ExchangesTable/types';
import type { FilterDataProperty as MarketTableProperties } from 'components/CoinMarketTable/types';
import type { FilterDataProperty as HoldersTableProperties } from 'components/CoinHoldersTable/types';

type PropertyTypes =
	| CoinListTableProperties
	| ExchangesTableProperties
	| MarketTableProperties
	| HoldersTableProperties;

export function sortNumber(data, property: PropertyTypes, direction: sortDirectionType) {
	let newArr;
	newArr = data.sort(function (a, b) {
		return direction === 'descend'
			? Number(a[property]) - Number(b[property])
			: Number(b[property]) - Number(a[property]);
	});

	return newArr;
}

export function sortString(data, property: PropertyTypes, direction: sortDirectionType) {
	let newArr;
	newArr = data.sort(function (a, b) {
		return direction === 'descend'
			? a[property].localeCompare(b[property])
			: b[property].localeCompare(a[property]);
	});

	return newArr;
}

export function sortNumberNested(
	data,
	property: PropertyTypes,
	direction: sortDirectionType,
	secondProperty: string,
) {
	let newArr;
	newArr = data.sort(function (a, b) {
		return direction === 'descend'
			? Number(a[property][secondProperty]) - Number(b[property][secondProperty])
			: Number(b[property][secondProperty]) - Number(a[property][secondProperty]);
	});

	return newArr;
}
